import { authApi } from '../../utils/api';

export const adminUsersPage = () => {
    const user = authApi.getCurrentUser();

    if (!user || user.rol !== 'admin') {
        return `
            <section class="page-content">
                <div class="container">
                    <div class="alert alert-danger">
                        <p>Bu sayfaya erişim yetkiniz yok.</p>
                        <a href="/" class="btn-primary">Ana Sayfaya Dön</a>
                    </div>
                </div>
            </section>
        `;
    }

    return `
        <section class="page-content admin-page">
            <div class="container">
                <div class="page-header">
                    <h1 class="page-title">Kullanıcı Yönetimi</h1>
                    <div class="header-actions">
                        <a href="/admin" class="btn-outline">← Admin Paneli</a>
                        <button class="btn-primary" id="addUserBtn">+ Yeni Kullanıcı</button>
                    </div>
                </div>

                <!-- Kullanıcı Ekleme/Düzenleme Modal -->
                <div id="userModal" class="modal" style="display: none;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2 id="modalTitle">Yeni Kullanıcı Ekle</h2>
                            <button class="modal-close" id="closeModal">&times;</button>
                        </div>
                        <form id="userForm" class="modal-form">
                            <input type="hidden" id="userId">
                            <div class="form-row">
                                <div class="form-group">
                                    <label for="ad">Ad *</label>
                                    <input type="text" id="ad" class="form-control" required>
                                </div>
                                <div class="form-group">
                                    <label for="soyad">Soyad *</label>
                                    <input type="text" id="soyad" class="form-control" required>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="userEmail">Email *</label>
                                <input type="email" id="userEmail" class="form-control" required>
                            </div>
                            <div class="form-group">
                                <label for="telefon">Telefon</label>
                                <input type="tel" id="telefon" class="form-control">
                            </div>
                            <div class="form-group">
                                <label for="userSifre">Şifre <span id="sifreNote">(zorunlu)</span></label>
                                <div class="input-with-btn">
                                    <input type="password" id="userSifre" class="form-control">
                                    <button type="button" class="btn-sm btn-info" id="generatePassword">Üret</button>
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="rol">Rol</label>
                                <select id="rol" class="form-control">
                                    <option value="user">Kullanıcı</option>
                                    <option value="admin">Admin</option>
                                </select>
                            </div>
                            <div id="userFormError" class="error-message" style="display: none;"></div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelBtn">İptal</button>
                                <button type="submit" class="btn-primary">Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>

                <div id="usersList" class="data-table-container">
                    <div class="loading">Yükleniyor...</div>
                </div>

                <!-- Hızlı Ruhsat Ekleme Modal -->
                <div id="quickRuhsatModal" class="modal" style="display: none;">
                    <div class="modal-content modal-large">
                        <div class="modal-header">
                            <h2 id="quickRuhsatTitle">Ruhsat Ekle</h2>
                            <button class="modal-close" id="closeQuickRuhsat">&times;</button>
                        </div>
                        <form id="quickRuhsatForm" class="modal-form" enctype="multipart/form-data">
                            <input type="hidden" id="qrUserId">

                            <div class="form-group">
                                <label for="qrImage">Ruhsat Görseli</label>
                                <input type="file" id="qrImage" class="form-control" accept="image/*">
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="qrPlaka">Plaka</label>
                                    <input type="text" id="qrPlaka" class="form-control" placeholder="34 ABC 123">
                                </div>
                                <div class="form-group">
                                    <label for="qrSahibi">Ruhsat Sahibi</label>
                                    <input type="text" id="qrSahibi" class="form-control">
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="qrMarka">Marka</label>
                                    <input type="text" id="qrMarka" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="qrModel">Model</label>
                                    <input type="text" id="qrModel" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="qrModelYili">Model Yılı</label>
                                    <input type="number" id="qrModelYili" class="form-control" min="1900" max="2030">
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="qrSasiNo">Şasi No</label>
                                    <input type="text" id="qrSasiNo" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="qrMotorNo">Motor No</label>
                                    <input type="text" id="qrMotorNo" class="form-control">
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="qrTcNo">TC No</label>
                                <input type="text" id="qrTcNo" class="form-control" maxlength="11">
                            </div>

                            <div id="qrError" class="error-message" style="display: none;"></div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelQuickRuhsat">İptal</button>
                                <button type="submit" class="btn-primary">Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Hızlı Poliçe Ekleme Modal -->
                <div id="quickPoliceModal" class="modal" style="display: none;">
                    <div class="modal-content modal-large">
                        <div class="modal-header">
                            <h2 id="quickPoliceTitle">Poliçe Ekle</h2>
                            <button class="modal-close" id="closeQuickPolice">&times;</button>
                        </div>
                        <form id="quickPoliceForm" class="modal-form">
                            <input type="hidden" id="qpUserId">

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="qpRuhsatId">Ruhsat</label>
                                    <select id="qpRuhsatId" class="form-control">
                                        <option value="">Ruhsat Seçin (Opsiyonel)</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="qpSigortaTipi">Sigorta Tipi *</label>
                                    <select id="qpSigortaTipi" class="form-control" required>
                                        <option value="">Seçin</option>
                                        <option value="trafik">Trafik</option>
                                        <option value="kasko">Kasko</option>
                                        <option value="dask">DASK</option>
                                        <option value="imm">İMM</option>
                                        <option value="e-kasko">E-Kasko</option>
                                        <option value="seyahat">Seyahat</option>
                                        <option value="tamamlayici">Tamamlayıcı Sağlık</option>
                                    </select>
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="qpPoliceNo">Poliçe No</label>
                                    <input type="text" id="qpPoliceNo" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="qpPrim">Prim Tutarı (TL)</label>
                                    <input type="number" id="qpPrim" class="form-control" step="0.01" min="0">
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="qpBaslangic">Başlangıç Tarihi</label>
                                    <input type="date" id="qpBaslangic" class="form-control">
                                </div>
                                <div class="form-group">
                                    <label for="qpBitis">Bitiş Tarihi</label>
                                    <input type="date" id="qpBitis" class="form-control">
                                </div>
                            </div>

                            <div class="form-row">
                                <div class="form-group">
                                    <label for="qpDurum">Durum</label>
                                    <select id="qpDurum" class="form-control">
                                        <option value="aktif">Aktif</option>
                                        <option value="beklemede">Beklemede</option>
                                        <option value="iptal">İptal</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for="qpMuayene">Muayene Tarihi</label>
                                    <input type="date" id="qpMuayene" class="form-control">
                                </div>
                            </div>

                            <div class="form-group">
                                <label for="qpNotlar">Notlar</label>
                                <textarea id="qpNotlar" class="form-control" rows="3"></textarea>
                            </div>

                            <div class="form-group">
                                <label for="qpBelge">Belge Ekle (PDF/Görsel)</label>
                                <input type="file" id="qpBelge" class="form-control" accept=".pdf,image/*" multiple>
                                <small class="form-hint">Poliçe PDF, evrak veya teminat belgesi ekleyebilirsiniz. Birden fazla dosya seçebilirsiniz.</small>
                            </div>

                            <div id="qpError" class="error-message" style="display: none;"></div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelQuickPolice">İptal</button>
                                <button type="submit" class="btn-primary">Kaydet</button>
                            </div>
                        </form>
                    </div>
                </div>

                <!-- Hızlı Belge Ekleme Modal -->
                <div id="quickBelgeModal" class="modal" style="display: none;">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h2 id="quickBelgeTitle">Belge Ekle</h2>
                            <button class="modal-close" id="closeQuickBelge">&times;</button>
                        </div>
                        <form id="quickBelgeForm" class="modal-form">
                            <input type="hidden" id="qbUserId">
                            <div class="form-group">
                                <label for="qbBelgeTipi">Belge Tipi</label>
                                <select id="qbBelgeTipi" class="form-control">
                                    <option value="evrak">Evrak</option>
                                    <option value="police_pdf">Poliçe PDF</option>
                                    <option value="teminat">Teminat Belgesi</option>
                                    <option value="diger">Diğer</option>
                                </select>
                            </div>
                            <div class="form-group">
                                <label for="qbDosya">Dosya Seç *</label>
                                <input type="file" id="qbDosya" class="form-control" accept=".pdf,image/*" multiple required>
                            </div>
                            <div class="form-group">
                                <label for="qbAciklama">Açıklama</label>
                                <input type="text" id="qbAciklama" class="form-control" placeholder="Belge açıklaması">
                            </div>
                            <div id="qbError" class="error-message" style="display: none;"></div>
                            <div class="modal-actions">
                                <button type="button" class="btn-outline" id="cancelQuickBelge">İptal</button>
                                <button type="submit" class="btn-primary">Yükle</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </section>
    `;
};
